// extracted by mini-css-extract-plugin
export default {"abandon_input":"Abandon_abandon_input__ZEcmP"};